module.exports = __webpack_public_path__ + "static/media/check-blue-rsm.c7a18f6c.svg";